import { Pipe, PipeTransform } from '@angular/core';
import { StatusColor } from 'src/app/models';

@Pipe({
    name: 'campaignStatusColor',
    standalone: true
})

export class CampaignStatusColorPipe implements PipeTransform {
  
    transform(statusId: number): string {
      return StatusColor[statusId]
    }
    
}